import { BaseTag } from 'mixs/base/base_mixin';
import { Scopes }  from 'apps/scopes';

class MaterialLots extends BaseTag {
  material_name(material_id){
    return Scopes.getMaterialData(material_id).name
  }
}

riot.mixin('calendars.material_lots', MaterialLots as riot.TagMixin)
